import {Container, Grid, Typography} from "@mui/material";
import {StyledButtonNoColor, StyledButtonOrange} from "../../styles/MyStyles";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import React from "react";
import {GetCookieInfo} from "../../logic/CookieManager";
import {DownloadFileFromBlob} from "../../logic/FileDownloader";
import {pdfjs} from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


export const GetMessageFilesComponent = (ticketId, messageId, files) => {
    if (!files) {
        return;
    }
    console.log(files);
    let messageFilesCollection = files.find(e => e.messageId === messageId);
    if (messageFilesCollection?.fileNames) {
        let items = [];

        messageFilesCollection.fileNames.forEach((fileName) => {
            items.push(FileComponent(ticketId, messageId, fileName));
        });
        return items;
    }
};

export const FileComponent = (ticketId, messageId, fileName) => {
    return (
        <Grid item key={fileName + Math.random().toString()}
                   style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', height: '40px', marginLeft: '30px' }}>

            <StyledButtonNoColor variant="contained" color="primary" size="small" onClick={() => downloadFile(ticketId, messageId, fileName)}>
                <CloudDownloadIcon style={{ fontSize: '20px' }} />
            </StyledButtonNoColor>
            <Typography style={{ marginLeft: '10px' }} variant="body2">{fileName}</Typography>
        </Grid>
    );
};


const downloadFile = async (ticketId, messageId, fileName)  => {
    try {
        const tokenCookie = GetCookieInfo('nplt');
        const response = await fetch(
            `${process.env.REACT_APP_TICKET_FILES_URL}/download`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + tokenCookie.value,
                },
                body: JSON.stringify({
                    'ticketId': ticketId,
                    'messageId': messageId,
                    'fileName': fileName
                })
            }
        );
        if (response.ok) {
            await DownloadFileFromBlob(response, fileName);
        } else {
            console.log('Download file failed.');
        }
    } catch (error) {
        console.log('An error occurred:', error);
    }
};